module.exports = __webpack_public_path__ + "media/images/pc/specials/common/plan_waso_house-32a7c8cf5623a3cd2bc42e24a0fdb446.jpg";